/* eslint-disable no-shadow */
import { GetWindParkKPITable } from "@/stores/actions/WindParkKPITable";
import { SetCurrentPark } from "@/stores/actions/WindParkSelect";
import { SetGoogleMaps } from "@/stores/actions/GoogleMaps";
import {
	GetWindPark,
	GetWindParkError,
	GetWindParkSuccess,
	GetTurbineStatus,
	SetGoogleConnection,
} from "@/stores/actions/WindPark";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { http } from "@/api";
import ErrorService from "@/services/common/ErrorService";
import WindTurbineStatusService from "@/services/wind/WindTurbineStatusService";
import UserModule from "../user/UserModule";
import DateTimeHandlerService from "@/services/common/date-time/DateTimeHandlerService";

const state = {
	status:             FetchStatus.Init,
	successMessage:     "",
	errorMessage:       "",
	error:              {},
	data:               {},
	turbinesStatus:     [],
	canConnectToGoogle: false,
};

const getters = { windTurbines: state => GetWindTurbinesFromPark(state.data) };

const actions = {

	[GetWindPark]: ({ commit, dispatch }, monitoringElementId) =>
	{
		commit(GetWindPark);
		http.get(`/WindParks/${monitoringElementId}`)
			.then((resp) =>
			{
				const turbines = resp.data.monitoringElementChild;
				dispatch(GetTurbineStatus, turbines);
				dispatch(SetCurrentPark, resp.data);
				commit(GetWindParkSuccess, resp);
			})
			.catch((error) =>
			{
				commit(GetWindParkError, error);
			});
	},
	[SetGoogleConnection]: async({ commit }) =>
	{
		try
		{
			await fetch("https://dns.google/resolve?name=google.com", { method: "GET" });
			commit(SetGoogleConnection, true);
		}
		catch (error)
		{
			commit(SetGoogleConnection, false);
		}
	},
	[GetTurbineStatus]: async({ commit, dispatch }, turbines) =>
	{
		try
		{
			const turbineNameMap = new Map(turbines.map(t => [ t.id, t.name ]));
			const turbineIds = turbines.map(t => t.id);
			const [ turbineStatus, connectionStatus ] = await Promise.all([
				WindTurbineStatusService.GetList(turbineIds),
				WindTurbineStatusService.GetTurbinesEquipments(turbineIds)
			]);
			const connectionStatusMap = new Map(
				connectionStatus.map(status => [ status.monitoringElementId, status ])
			);
			let turbinesStatus = turbineStatus.map(status => ({
				...status,
				name:             turbineNameMap.get(status.monitoringElementId) || "Unknown",
				connectionStatus: connectionStatusMap.get(status.monitoringElementId) || null
			}));
			if (UserModule.state.user.role === "Demo")
			{
				for (let i = 3; i <= 25; i++)
				{
					const windTurbine = {
						monitoringElementId: i,
						name:                turbinesStatus[0].name.substring(0, 4) === "FM01" ?
							`FM01-WTG0${i}` :
							`FM02-WTG0${i}`,
						generatingUnitStatus:     1,
						formattedLastKPIDateTime: DateTimeHandlerService.GetLocalDateTime(),
						kpi:                      1,
						kpiUnit:                  "%",
						kpiValue:                 0,
						connectionStatus:         {
							formattedLastConnectedDateTime: DateTimeHandlerService.GetLocalDateTime(),
							isOnline:                       true,
							monitoringElementId:            i,
						}
					};
					turbinesStatus.push(windTurbine);
				}
			}
			commit(GetTurbineStatus, turbinesStatus);

			// São feitos aqui para garantir que o turbineStatus já exista no estado.
			dispatch(GetWindParkKPITable, turbinesStatus);
			dispatch(SetGoogleMaps, turbines);
		}
		catch (e)
		{
			const error = ErrorService.HandleError(e);
			commit(GetWindParkError, error);
		}
	}

};
const mutations = {
	[GetWindPark]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GetTurbineStatus]: (state, turbinesStatus) =>
	{
		state.turbinesStatus = turbinesStatus;
	},
	[GetWindParkSuccess]: (state, resp) =>
	{
		state.status = FetchStatus.Loaded;
		state.data = resp.data;
	},
	[GetWindParkError]: (state, error) =>
	{
		state.status = FetchStatus.Error;
		state.error = error.response;
	},
	[SetGoogleConnection](state, status)
	{
		state.canConnectToGoogle = status;
	},
};

export default {
	state,
	actions,
	mutations,
	getters,
};
